import SelectOptions from "pages/PanelPage/components/selectedAssessment/assessmentResults/takerResults/questionsTable/SelectOptions/SelectOptions";

export default SelectOptions;
